import { render, staticRenderFns } from "./dial_number.vue?vue&type=template&id=08882920&scoped=true&"
import script from "./dial_number.vue?vue&type=script&lang=js&"
export * from "./dial_number.vue?vue&type=script&lang=js&"
import style0 from "./dial_number.vue?vue&type=style&index=0&id=08882920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08882920",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
